import * as types from '../types';
import { IDataTranscriberDraft } from '../common/defaults';

export interface IDataTranscriberState {
  DataTranscriberDrafts: IDataTranscriberDraft[];
  DataTranscriberFormIoFormId: string;
}

const initialState: IDataTranscriberState = {
  DataTranscriberDrafts: [],
  DataTranscriberFormIoFormId: '',
};

export default (state: IDataTranscriberState = initialState, action: any) => {
  let _state = { ...state };
  switch (action.type) {
    case types.LOAD_ALL_TYPES_INTO_STORE:
      return {
        ...state,
        DataTranscriberDrafts: [
          ...state.DataTranscriberDrafts,
          ...action.value,
        ],
      };
    case types.GET_FORM_IO_FORM_ID:
      return {
        ...state,
        DataTranscriberFormIoFormId: action.value,
      };
    default:
      return state;
  }
};
